import 'Src/less/automotive/tires-landing-page.less';
import TireFitmentLookup from './components/TireFitmentLookup.vue';
import TireSizeLookupService from './services/TireSizeLookupService';
import Vue from 'vue';
import { BlogCategories, BlogTagGroups } from 'JS/services/BlogService';
import { CustomerVehicleService } from 'JS/services/automotive/CustomerVehicleService';
import { initializeAsyncBlogCarousel } from 'Src/js/utilities/blog';
import { initializeChangeStoreButton } from '../shared/utils/store';
import { lazyLoadImages } from 'JS/global/images';

const vehicleForm = document.getElementById('tlpFitmentVue');
if (vehicleForm) {
	new Vue({
		el: vehicleForm,
		render: h => h(TireFitmentLookup),
		provide: {
			CustomerVehicleService: new CustomerVehicleService(),
			TireSizeLookupService: new TireSizeLookupService()
		}
	});
}

initializeChangeStoreButton('.alp-store__change', 'auto');

initializeAsyncBlogCarousel('#tlpBlogCarousel', {
	heading: 'Tire Care Tips & Advice',
	viewAllLink: 'https://www.farmandfleet.com/blog/tag/tires/',
	query: {
		categories: [BlogCategories.Automotive],
		perPage: 12,
		tags: BlogTagGroups.Tires, 
	},

});

lazyLoadImages(document.querySelector('#tlp') as HTMLElement);